module.exports = __webpack_public_path__ + "img/tag_yy.085b6d03.svg";